import PropTypes from "prop-types";
import CloseButton from "../CloseButton";

const withDismissible = ({
  component: WrappedComponent,
  className,
  shouldRenderKey
}) => {
  const WithDismissible = props => {
    const { onDismiss, [shouldRenderKey]: shouldRender } = props;

    if (!shouldRender) return null;

    return (
      <WrappedComponent
        {...props}
        render={props => <CloseButton {...props} onClick={onDismiss} />}
        className={className}
      />
    );
  };

  WithDismissible.propTypes = {
    onDismiss: PropTypes.func.isRequired
  };

  return WithDismissible;
};

export default withDismissible;
